<style lang="stylus" scoped>
.bar-wrap {
  width: 380px;
  height: 200px;
  padding: 18px 0;
}

.instruction {
  display: flex;
  justify-content: space-between;

  .item-name {
    margin-bottom: 5px;
    color: #77CAD8;
    font-size: 14px;
  }

  .item-num {
    color: #fff;
    font-size: 20px;
    font-weight: 400;
    text-align: center;
  }
}

.line {
  width: 380px;
  height: 200px;

  .main {
    width: 100%;
    height: 100%;
  }
}
</style>

<template>
  <div class="bar-wrap">
    <div class="line">
      <div class="main"></div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import boxWrap from 'components/dashboard/common/boxWrap';
export default {
  data() {
    return {
      color: ['#AF69FF', '#00A0EA', '#13AF68', '#FFB52B', '#920784'],
      myChart: {}
    }
  },
  components: {
    boxWrap
  },
  methods: {
    init() {
      window.addEventListener('resize', function () {
        this.myChart.resize()
      }.bind(this))
    }
  },
  mounted() {
    // 基于准备好的dom，初始化echarts实例
    this.myChart = echarts.init(document.querySelector('.line .main'));
    this.myChart.setOption({
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: ['家庭人口', '帮扶金额'],
        textStyle: {
          color: "#fff"
        }
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      toolbox: {
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: ['章*晨', '张*敏', '陈*飞', '陈*泳', '刘*明', '周*轮', '苏*曼', '李*万', '王*说', '顾*网'],
        axisTick: {
          show: false
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: "#00c7ff",
            width: 1,
            type: "solid"
          }
        },
        splitLine: {
          show: false
        }
      },
      yAxis: {
        type: 'value',
        axisTick: {
          show: false
        },
        axisLine: {
          show: true,
          lineStyle: {
            color: "#00c7ff",
            width: 1,
            type: "solid"
          }
        },
        splitLine: {
          show: false
        }
      },
      series: [
        {
          name: '家庭人口',
          type: 'line',
          smooth: true,
          showSymbol: false,
          stack: '总量',
          itemStyle: {
            normal: {
              color: '#FF9E2C'
            }
          },
          data: [2, 3, 2, 4, 3, 1, 3, 5, 2, 4]
        },
        {
          name: '帮扶金额',
          type: 'line',
          smooth: true,
          showSymbol: false,
          stack: '总量',
          itemStyle: {
            normal: {
              color: '#31C2E2'
            }
          },
          data: [2045, 1935, 1902, 1852, 1832, 1789, 1780, 1747, 1734, 1696]
        }
      ]
    })
    this.init();
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?a1056b8e